import { render, staticRenderFns } from "./yishengliebiao.vue?vue&type=template&id=978ffe66&scoped=true&"
import script from "./yishengliebiao.vue?vue&type=script&lang=js&"
export * from "./yishengliebiao.vue?vue&type=script&lang=js&"
import style0 from "./yishengliebiao.vue?vue&type=style&index=0&id=978ffe66&rel=stylesheet%2Fless&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "978ffe66",
  null
  
)

export default component.exports